import logo from './logo.svg';
import {
  Route,
  Routes
} from "react-router-dom";

import './App.css';
import Wave from './pages/Wave';
import Message from './pages/Message';
import Tap from './pages/Tap';
import Shuffle from './pages/Shuffle';
import AfterShuffle from './pages/AfterShuffle';
import Ask from './pages/Ask';
import AskQuestion from './pages/AskQuestion';
import SignIn from './pages/SignIn';
import SignMail from './pages/SignMail';
import ProfileCreate from './pages/ProfileCreate';
import Profile from './pages/Profile';
import CreateEvent from './pages/CreateEvent';
import EventCreate from './pages/EventCreate';
import InitiateWave from './pages/InitiateWave';



function App() {
  return (
    <div className="">
        
        <Routes>
        <Route path='/' element={<SignIn />} />
  <Route path='/signmail' element={<SignMail />} />
  <Route path='/profilecreate' element={<ProfileCreate />} />
  <Route path='/profile' element={<Profile />} />
  <Route path='/createevent' element={<CreateEvent />} />
  <Route path='/createeventfield' element={<EventCreate />} />
  <Route path='/initiate' element={<InitiateWave />} />
  <Route path="/wave" element={<Wave />}>
    {/* <Route
      path="messages"
      element={<Message />}
    />
    <Route path="tasks" element={<DashboardTasks />} /> */}
  </Route>
  <Route path="/message" element={<Message />} />
  <Route path="/tap" element={<Tap />} />
  <Route path="/shuffle" element={<Shuffle />} />
  <Route path="/aftershuffle" element={<AfterShuffle />} />
  <Route path="/ask" element={<Ask />} />
  <Route path="/askquestion" element={<AskQuestion />} />
  

</Routes>
    </div>
  );
}

export default App;
